import { Injectable } from '@angular/core';
import { AngularFireDatabase, AngularFireList} from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { DateService } from 'app/date/date.service';
import { SessionService } from 'app/sessions/session.service';
import { UtilService } from './util.service';
@Injectable()
export class HRMSService {
    departmentHeads : AngularFireList<any>;
    today:Date;
    date:string;
  constructor(private firebase : AngularFireDatabase, private dateService:DateService, private ss:SessionService, private util:UtilService) {
    this.today = new Date();
    this.date = this.today.getFullYear()+"-"+(this.today.getMonth()+1)+"-"+this.today.getDate();
   }
getDepartmentHeads()
{
  this.departmentHeads = this.firebase.list('departmentHeads');
  return this.departmentHeads;
}
addDepartment(department)
{
    return this.firebase.list('departments').push(department);
}
getAllDepartments()
{
    return this.firebase.list('departments');
}
getDepartment(id)
{
    //return this.firebase.list('departments', ref=> ref.orderByKey().equalTo(id));
    var rootRef = firebase.database().ref('departments');
    return rootRef.child(id);
}
updateDepartment(department,id)
{
    return firebase.database().ref('departments').child(id).update(department);
}

getAllDesignations()
{
    return this.firebase.list('designations');
}
getDesignation(id)
{
    var rootRef = firebase.database().ref('designations');
    return rootRef.child(id);
}
addDesignation(designation)
{
    return this.firebase.list('designations').push(designation);
}
updateDesignation(designation,id)
{
    return firebase.database().ref('designations').child(id).update(designation);
}

getAllAssets()
{
    return this.firebase.list('assets');
}
getAssets(id)
{
    var rootRef = firebase.database().ref('assets');
    return rootRef.child(id);
}
addAssets(assets)
{
    return this.firebase.list('assets').push(assets);
}
updateAssets(assets,id)
{
    return firebase.database().ref('assets').child(id).update(assets);
}

getAllLeaves()
{
    return this.firebase.list('leaves');
}
getLeaves(id)
{
    var rootRef = firebase.database().ref('leaves');
    return rootRef.child(id);
}
addLeaves(assets)
{
    return this.firebase.list('leaves').push(assets);
}
updateLeaves(assets,id)
{
    return firebase.database().ref('leaves').child(id).update(assets);
}

getAllHolidays()
{
    return this.firebase.list('holidays');
}
getHolidays(id)
{
    var rootRef = firebase.database().ref('holidays');
    return rootRef.child(id);
}
addHolidays(holidays)
{
    return this.firebase.list('holidays').push(holidays);
}
updateHolidays(holidays,id)
{
    return firebase.database().ref('holidays').child(id).update(holidays);
}

deleteHolidays(id)
{
    return firebase.database().ref('holidays').child(id).remove();
}

deleteDepartment(id)
{
    return firebase.database().ref('departments').child(id).remove();
}
deleteDesignation(id)
{
    return firebase.database().ref('designations').child(id).remove();
}
deleteAssets(id)
{
    return firebase.database().ref('assets').child(id).remove();
}
deleteLeaves(id)
{
    return firebase.database().ref('leaves').child(id).remove();
}

applyLeave(data)
{
    return firebase.database().ref('employeeLeaves').push(data);
}

getMyLeaveList(uid)
{
    return this.firebase.list('employeeLeaves', ref=> ref.orderByChild('uid').equalTo(uid));
}

getMyLeaveData(leaveId)
{
    return firebase.database().ref("employeeLeaves").child(leaveId);
}
updateLeave(leaveId,data)
{
    return firebase.database().ref("employeeLeaves").child(leaveId).update(data);
}
cancelLeave(leaveId)
{
    return firebase.database().ref("employeeLeaves").child(leaveId).remove();
}
onBoard(data)
{
    return firebase.database().ref("users").child(data.uid).set(data);
}
getCurrency()
{
    return firebase.database().ref("settings").child("general");
}
getEmployeesLeaveList()
{
    return this.firebase.list("employeeLeaves");
}
acceptLeaveRequest(leaveId,status)
{
    return firebase.database().ref("employeeLeaves").child(leaveId).child("status").set(status);
}
offboard(uid)
{
    return firebase.database().ref("users").child(uid).child("boardingStatus").set("offboard");
}
getApprovedLeaves(uid)
{
    return this.firebase.list("employeeLeaves", ref=>ref.orderByChild("uid").equalTo(uid));
}
find(value,from)
{
    return firebase.database().ref(from).orderByChild("value").equalTo(value);
}
isleaveAdded(value)
{
    return firebase.database().ref("leaves").orderByChild("designation").equalTo(value);
}
checkExistsInEmployee(child,value)
{
    return firebase.database().ref("users").orderByChild(child).equalTo(value);
}
checkExistsInEmployeeLeaves(type)
{
    return firebase.database().ref("employeeLeaves").orderByChild("leaveType").equalTo(type);
}
checkExistsInEmployeeAssets(id)
{
    return firebase.database().ref("users").orderByChild("assets").equalTo(id);
}
getLeaveType(id)
{
    return firebase.database().ref("leaves").child(id);
}
getLossOfPayLeaves(id)
{
    return firebase.database().ref("employeeLeaves").child(id);
}
updateSalary(month,year,uid,data)
{
    var date = new Date();
    var childName = date.getUTCFullYear()+"-"+(date.getMonth()+1);
    //return firebase.database().ref("employeeSalaries").child(childName).child(uid).update(data);
    return firebase.database().ref("employeeSalaries").child(String(year)).child(String(month)).child(uid).update(data);
}
getDepartmentName(id)
{
    return firebase.database().ref("departments").child(id);
}
getDesignationName(id)
{
    return firebase.database().ref("designations").child(id);
}
getSalary(month,year,uid)
{
    var date = new Date();
    var childName = date.getUTCFullYear()+"-"+(date.getMonth()+1);
    //return firebase.database().ref("employeeSalaries").child(childName).child(uid);
    return firebase.database().ref("employeeSalaries").child(String(year)).child(String(month)).child(uid);
}
getAllLeavesOfSpecificDesignation(designation)
{
    return this.firebase.list('leaves', ref=> ref.orderByChild("designation").equalTo(designation));
}
checkDateExistsInHoliday(date)
{
    return firebase.database().ref("holidays").orderByChild("date").equalTo(date);
}
getUserSalaryForMonth(year,month,uid)
{
    var date = new Date();
    //var childName = date.getUTCFullYear()+"-"+(month+1);
    //return firebase.database().ref("employeeSalaries").child(childName).child(uid);
    //console.log("uid",year,(month+1),uid);
    return firebase.database().ref("employeeSalaries").child(String(year)).child(String(month)).child(uid);
}
updateSalaryForThisMonth(year,month)
{
    firebase.database()
        .ref('users')
        .once('value')
        .then(data => 
        {
            //console.log("data",data.val());
            data.forEach(userData=>{
            var user = userData.val();
            //console.log("userData",userData.val(),userData.key);
            // if(user.role == 'super admin' || user.role == 'admin' || user.role == 'driver' || user.role == 'supervisor' || user.role == 'employee')
            if(user.role != 'customer')
            {
                firebase.database()
                .ref('employeeSalaries')
                .child(year).child(month)
                .orderByKey().equalTo(userData.key)
                .once('value')
                .then(salary => 
                {
                    if(salary.numChildren()>0)
                    {
                        //console.log("salary",salary.val());
                        
                        salary.forEach(s=>{
                            firebase.database().ref("employeeSalaries").child(year).child(month).child(s.key).child("status").set("Processed").then(()=>{
                            //console.log("Salary Processed Successfully");
                            });
                        });
                    }
                    else
                    {
                        //console.log("no user salary found");
                        var salaryData = {
                            allowance: user.allowance,
                            basic: user.basic,
                            computedSalary: user.salary,
                            conveyance: user.conveyance?user.conveyance:'',
                            da: user.da,
                            date: this.dateService.getTodaysDate(),
                            hra: user.hra,
                            lastUpdatedOn: this.dateService.getTodaysDate() +", "+this.dateService.getTimeandDate().time,
                            medicalAllowance: user.medicalAllowance,
                            others: user.others,
                            overtime: user.overtime?user.overtime:'',
                            leaves: user.leaves?user.leaves:'',
                            pf: user.pf,
                            status: "Processed",
                            tax: user.tax,
                            tds: user.tds
                        }
                        //console.log("salaryData",userData.key,user.name,salaryData);
                        firebase.database().ref("employeeSalaries").child(year).child(month).orderByChild("uid").equalTo(userData.key).once("value").then((userSalary)=>{
                            if(userSalary.numChildren()>0)
                            {
                                firebase.database().ref("employeeSalaries").child(year).child(month).child(userData.key).child("status").set("Processed").then(()=>{
                                    //console.log("Salary Processed Successfully");
                                    });
                            }
                            else
                            {
                                firebase.database().ref("employeeSalaries").child(year).child(month).child(userData.key).set(salaryData).then(()=>{
                                    //console.log("Salary Processed Successfully");
                                    });
                            }
                        });
                        
                    }
                    
                });
            }
            });
        });
        firebase.database().ref("updateMonthlySalary").push({"month":year+"-"+month});
        }
getSelectedMonthSalaryg(month)
{
    var date = new Date();
    var ref = "employeeSalaries/"+String(date.getUTCFullYear())+"/"+month;
    return this.firebase.list(ref);
}
getSelectedMonthSalary(month,year)
{
    var date = new Date();
    var ref = String(year)+"/"+month;
    return this.firebase.list("employeeSalaries/"+ref);
}
checkSalaryProcessed(year,month)
{
    return firebase.database().ref("employeeSalaries").child(year).child(month);
}
checkSalaryProcessedForEmployee(child)
{
    return firebase.database().ref("updateMonthlySalary").orderByChild("month").equalTo(child);
}
disbleProcessSalary(child)
{
    firebase.database().ref("updateMonthlySalary").orderByChild("month").equalTo(child).once("value").then((data)=>{
        data.forEach(d=>{
            firebase.database().ref("updateMonthlySalary").child(d.key).remove();
        });
    });
}
clockIn(key)
{
    var childKey = key?key:firebase.database().ref("attendance").child(this.ss.getEmployeeId).push().key;
    var data = {
        clockIn: this.dateService.getTimeandDate().time,
        createdAt : this.dateService.getTimeandDate().timeStamp,
        updatedAt : this.dateService.getTimeandDate().timeStamp
    };
    return firebase.database().ref("attendance").child(this.ss.getEmployeeId).child(this.date).child("logs").child(childKey).update(data);
}
clockOut(key,data)
{
    return firebase.database().ref("attendance").child(this.ss.getEmployeeId).child(this.date).child("logs").child(key).update(data);
}
getLastClockInOutInfo()
{
    var rootRef = "attendance/"+this.ss.getEmployeeId+"/"+this.date+"/logs";
    //console.log("this.date",this.date);
    return this.firebase.list(rootRef, ref=>ref.limitToLast(1));
}
getLastClockInfo()
{
    return firebase.database().ref("attendance").child(this.ss.getEmployeeId).child(this.date).child("logs").limitToLast(1);
}
getLastClockInOut(id,dateInput)
{
    var date = dateInput=="today"?this.date:dateInput;
    return firebase.database().ref("attendance").child(id).child(date).child("logs").limitToLast(1);
}
getFirstClockInOut(id,dateInput)
{
    var date = dateInput=="today"?this.date:dateInput;
    return firebase.database().ref("attendance").child(id).child(date).child("logs").limitToFirst(1);
}
getMyTodaysAttendance(eid)
{
    var ref = "attendance/"+eid+"/"+this.date+"/logs";
    return this.firebase.list(ref);
}
getUsersTodaysAttendance(eid)
{
    return firebase.database().ref("attendance").child(eid).child(this.date).child("logs").limitToFirst(1);
}
getAttendance(eid,date1,date2)
{
    var ref = "attendance/"+eid;
    return this.firebase.list(ref, ref=>ref.orderByChild("timeStamp").startAt(date1).endAt(date2));
}
getAllEmployeeAttendance()
{
    return this.firebase.list("/attendance");
}
getEmployeeAttendance(uid)
{
    return firebase.database().ref("attendance").child(uid);
}
getEmployeeByEmployeeId(employeeId)
{
    var ref = "/users";
    return this.firebase.list(ref, ref=>ref.orderByChild("employeeId").equalTo(employeeId));
}
getAllEmployeeTodaysAttendance(id)
{
    var ref = "attendance/"+id+"/"+this.date+"/logs";
    return this.firebase.list(ref);
}
findDate(date1,date2)
{
    return firebase.database().ref("attendanceTestData").child(this.ss.getEmployeeId).orderByKey().startAt(date1).endAt(date2);
}
getAllEmployeeAttendanceSearch(uid,date1,date2)
{
    var ref = "attendance/"+uid;
    return this.firebase.list(ref, ref=> ref.orderByChild("timeStamp").startAt(date1).endAt(date2));
}
updateAttendance(uid,date,attendanceId,data)
{
    return firebase.database().ref("attendance").child(uid).child(date).child("logs").child(attendanceId).update(data);
}
addAttendance(uid,date,data,key)
{
    return firebase.database().ref("attendance").child(uid).child(date).child("logs").child(key).update(data);
}
checkIsThisHoliday(date)
{
    return firebase.database().ref("holidays").orderByChild("date").equalTo(date);
}
changeAttendanceStatus(uid,date,status)
{
    return firebase.database().ref("attendance").child(uid).child(date).child("status").set(status);
}
getEmployeeLeavesById(uid)
{
    return firebase.database().ref("employeeLeaves").orderByChild("uid").equalTo(uid);
}
getPreviousDaysClockOutData()
{
    var date = new Date(this.today.getFullYear()+"/"+(this.today.getMonth()+1)+"/"+(this.today.getDate()-1));
    //console.log("this.util.getDateSearchForm(date)",this.util.getDateSearchForm(date));
    return firebase.database().ref("attendance").child(this.ss.getEmployeeId).child(this.util.getDateSearchForm(date)).child("logs").limitToLast(1);
}
updatePReviousDatClockout(key,data)
{
    var date = new Date(this.today.getFullYear()+"/"+(this.today.getMonth()+1)+"/"+(this.today.getDate()-1));
    return firebase.database().ref("attendance").child(this.ss.getEmployeeId).child(this.util.getDateSearchForm(date)).child("logs").child(key).update(data);
}
getAllEmployeesOfBranch(branch)
{
    return this.firebase.list("users",  ref=> ref.orderByChild("branch").equalTo(branch));
}
getNewLeaveNotif()
{
    return firebase.database().ref("employeeLeaves").orderByChild("notif").equalTo("unread");
}
getMyLeaveNotification(uid)
{
    return firebase.database().ref("employeeLeaves").orderByChild("uid").equalTo(uid);
}
addAttendanceNotification(uid,date,attendanceKey,status)
{
    var data = {
        uid:uid,
        date:date,
        status: status,
        notif: "unread"
    }
    return firebase.database().ref("attendance").child(attendanceKey).update(data);
}
changeNotifStatusToRead(id,ref)
{
    return firebase.database().ref(ref).child(id).child("notif").set("read");
}
sendAttendanceNotif(eid,date,status,notif)
{
    var ref = eid+"-"+date;
    var data = {
        status: status,
        notif: notif,
        eid: eid,
        date: date,
        createdAt: this.dateService.getTimeandDate().timeStamp,
        updatedAt: this.dateService.getTimeandDate().timeStamp
    }
    return firebase.database().ref("attendanceNotification").child(ref).update(data);
}
updateAttendanceNotif(id,notif)
{
    var data = {
        notif: notif,
        updatedAt: this.dateService.getTimeandDate().timeStamp
    }
    return firebase.database().ref("attendanceNotification").child(id).update(data);
}
getMyAttendanceNotification(eid)
{
    return firebase.database().ref("attendanceNotification").orderByChild("eid").equalTo(eid);
}
getAttendanceNotification()
{
    return firebase.database().ref("attendanceNotification").orderByChild("notif").equalTo("unread");
}
changeLeaveNotifStatus(leaveId)
{
    return firebase.database().ref("employeeLeaves").child(leaveId).child("notif").equalTo("unread");
}
}



// WEBPACK FOOTER //
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/hrms/shared/hrms.service.ts